import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@app/services/User/user.service';
import Swal from 'sweetalert2';
import axios from 'axios';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-verify',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.css']
})
export class PaymentFailedComponent implements OnInit {
  userInfoId: any;
  itemType: any;
  orderId:any;
  
  constructor(
    private userService: UserService,
    private route: ActivatedRoute, 
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      debugger
      this.userInfoId = params['userInfoId'];
      this.itemType = params['itemType'];
      this.orderId = params['orderId'];
    });
    //this.verifyPayment();
  }
  API_BASE_PATH = environment.API_URL;

  //Phone Pay
  async verifyPayment() { 
    const response = await axios.get(`${this.API_BASE_PATH}payment/validate/${this.userInfoId}/${this.itemType}/${this.orderId}`)
    if (response.data) {
      Swal.fire({
        title: response.data.url,
        icon: "success",
        showConfirmButton: false,
        timer: 7700
      });

    } else {
      Swal.fire({
        title: response.data,
        icon: "error",
        showConfirmButton: false,
        timer: 7000
      });
    }
  }
}
